import React, { useContext } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { CalendarIntakeBookContext } from '../contexts/CalendarIntakeBookProvider';
import { MonthlyIntakeBookContext } from '../contexts/MonthlyIntakeBookProvider';
import MonthlyIntakeBookHeader from '../components/MonthlyIntakeBookHeader';
import MonthlyIntakeBookDetail from '../components/MonthlyIntakeBookDetail';
import UploadFileModel from '../../components/UI/UploadFile/UploadFileModal';
import ProcessingSpinner from '../../components/UI/Spinner/ProcessingSpinner';
import { RequestStatus } from '../../common/const/RequestStatus';
import { getMonthAndYearOnlyByDate } from '../../common/utility/utility'
import UnblockContract from '../../components/UI/Modal/UnblockContract';
import './monthlyintakebook.css';

function MonthlyIntakeBookDetailContainer(props) {
    const { intakeBookStartDate, isLoading } = useContext(CalendarIntakeBookContext);
    const { handlerOnUploadIntakeBookClick, handlerOnDeleteIntakeBookClick, selectedRowIndex,
        selectedIntakeDtl, showUploadFileModel, acceptFileType, modelHeaderTitle, resetIntakeBookFlags,
        monthlyIntakeBookDetails, checkBoxSelectionHandler, submitSelectedIntakeHandler, handlerOnMonthlyUnblockRequestIconClick ,showUnblockMonthlyRequestModel,
        resetMonthlyUnblockRequestFlag, onSubmitMonthlyUnblockRequestHandler,setMonthlyDataHandler} = useContext(MonthlyIntakeBookContext);

    return (
        <Container className="monthly-intakebook-container">
            <Row className={intakeBookStartDate ? "monthly-intakebook-header-row" : "monthly-intakebook-header-row monthly-intakebook-header-row-transparent"}>
                {
                    intakeBookStartDate && <MonthlyIntakeBookHeader BusinessPartnerCode={props.BusinessPartnerCode} />
                }
            </Row>
            <Row className="monthly-intakebook-details-row">
                {showUploadFileModel &&
                    <UploadFileModel showModel={showUploadFileModel}
                        acceptFileType={acceptFileType}
                        showHeader={showUploadFileModel}
                        onHideHandler={resetIntakeBookFlags}
                        headerTitle={modelHeaderTitle}
                        handlerOnUploadClick={handlerOnUploadIntakeBookClick}
                        isCashRegister={true}
                        allowedFileType={"fileformat"}
                        handlerOnDeleteFileClick={handlerOnDeleteIntakeBookClick}
                        isModifying={false}
                        selectedRevenueCashRegisterFile={null}
                        UserId={props.UserId}
                        selectedRowIndex={selectedRowIndex}
                        selectedRevenue={selectedIntakeDtl}
                    />
                }
                {
                    intakeBookStartDate && !isLoading && <div className="monthly-intakebook-details-main">
                        <MonthlyIntakeBookDetail BusinessPartnerCode={props.BusinessPartnerCode}
                            intakeBookStartDate={intakeBookStartDate}
                            monthlyIntakeBookDetails={monthlyIntakeBookDetails}
                            checkBoxSelectionHandler={checkBoxSelectionHandler}
                            submitSelectedIntakeHandler={submitSelectedIntakeHandler}
                            handlerOnMonthlyUnblockRequestIconClick={handlerOnMonthlyUnblockRequestIconClick} />
                    </div>
                }
                {showUnblockMonthlyRequestModel &&
                    <UnblockContract showModel={showUnblockMonthlyRequestModel}
                        onHideHandler={resetMonthlyUnblockRequestFlag}
                        onSubmitUnblockRequestHandler={onSubmitMonthlyUnblockRequestHandler}
                        setRevenueData={setMonthlyDataHandler}
                        rowIndex={selectedRowIndex}
                        row={selectedIntakeDtl}
                        BusinessPartnerCode={props.BusinessPartnerCode}
                        // RevenueDate={revenueDate}
                    />
                }
                {
                    isLoading ? <ProcessingSpinner Status={RequestStatus.Inprogress.id}
                        BusinessPartnerCode={props.BusinessPartnerCode}
                        RevenueDate={getMonthAndYearOnlyByDate(intakeBookStartDate)}
                    />
                        : undefined
                }
            </Row>
        </Container>
    )
}

export default MonthlyIntakeBookDetailContainer;
